/**
 * @generated SignedSource<<495a4867ac660787d82359d05700a7e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type JobType = "freelance" | "permanent";
export type RateMode = "day" | "hour" | "month" | "week" | "year";
import { FragmentRefs } from "relay-runtime";
export type CompensationSummary_User$data = {
  readonly profile: {
    readonly clientRate: {
      readonly value: number;
    } | null | undefined;
    readonly currency: {
      readonly code: string | null | undefined;
    } | null | undefined;
    readonly freelancerRate: {
      readonly value: number;
    } | null | undefined;
    readonly jobTypes: ReadonlyArray<JobType>;
    readonly rateMode: RateMode | null | undefined;
  } | null | undefined;
  readonly self: boolean | null | undefined;
  readonly " $fragmentType": "CompensationSummary_User";
};
export type CompensationSummary_User$key = {
  readonly " $data"?: CompensationSummary_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompensationSummary_User">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompensationSummary_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "self",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Currency",
          "kind": "LinkedField",
          "name": "currency",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Money",
          "kind": "LinkedField",
          "name": "freelancerRate",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Money",
          "kind": "LinkedField",
          "name": "clientRate",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobTypes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rateMode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "8bc87e150a186e578b139174134d2fb6";

export default node;
